import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
export const getListAccountReport = () => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/account-report/detail',
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_ACCOUNT_REPORT,
        ActionTypes.FETCHED_ACCOUNT_REPORT,
        [ActionTypes.FETCHED_ACCOUNT_REPORT_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};
